import React from 'react';


import {
    View,
    StyleSheet,
    ScrollView,
    Image,
    Dimensions,
    Text,
    // ToastAndroid,
    Alert,
    Keyboard,
    Switch,
    ImageBackground, TouchableOpacity, TextInput
} from "react-native";

import {RFValue} from "react-native-responsive-fontsize";
import {AntDesign, Ionicons} from "@expo/vector-icons";
import Config from "../components/Config";



import { Formik } from 'formik';
import * as Yup from "yup";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";


// import Toast from "react-native-tiny-toast";
import ToastNotification from 'react-native-toast-notification'


import * as ImagePicker from 'expo-image-picker';


const schema = Yup.object().shape({

    full_name : Yup.string().required('field is required').min('4',' Please type more ...'),
    email : Yup.string().email('email not valid').required('field is required').min('3',' Please type more ...'),
    trc20 : Yup.string().required('field is required').min('5',' Please type more ...'),
    password : Yup.string().required('field is required').min('5',' Please type more ...'),
    referral : Yup.string().min('5',' Please type more ...'),
});


const Register = ({navigation})=>{

    let[disable,setDisable] = React.useState(false);

    let [toast,setToast] = React.useState(false);




    const confirm =async (values)=>{




        // Toast.showLoading('Send Data To Server ...');

        setToast('Send Data To Server ...');

        const timeoutId = setTimeout(() => {
            setToast(false);
        }, 3000);

        let formData = new FormData();
        formData.append('password', values.password);
        formData.append('full_name', values.full_name);
        formData.append('trc20', values.trc20);
        formData.append('email', values.email);
        formData.append('referral', values.referral);












        let res = await axios.post(
            `${Config.base}/api/v1/register`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",

                }
            }
        );
        setDisable(false);
        Keyboard.dismiss();



        setToast(false);
        // Toast.hide('');
        if(res.data.status == 200){

            await AsyncStorage.setItem('token', res.data.token);


            navigation.reset({
                index: 0,
                routes: [{ name: "Home" }],
            });
        }else{
            // Toast.show(res.data.message);
            setToast(res.data.message);

            const timeoutId = setTimeout(() => {
                setToast(false);
            }, 3000);
        }



    }



    return (

        <View style={{flex : 1}}>
            <ImageBackground
                source={{uri: 'https://metamax.network/public/appBg.jpg'}}
                // source={{uri: 'https://img.freepik.com/free-photo/minimalistic-still-life-arrangement-with-cryptocurrency_23-2149102090.jpg?w=740&t=st=1694093218~exp=1694093818~hmac=d9334eec05ae93b0588ef7cd2b5b01df82be982db4bb333380c6e5760732c18e'}}
                resizeMode="cover" style={{flex : 1}}>
                <View style={styles.headercon}>
                    <TouchableOpacity style={{backgroundColor : 'transparent'}} onPress={()=>navigation.goBack()}>
                        <Ionicons   name="return-up-back" size={RFValue(35)} color="#FFF" />
                    </TouchableOpacity>
                    <Text style={styles.header}>
                        Register
                    </Text>
                </View>






                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        'full_name' : '',
                        'email' : '',
                        'password' : '',
                        'trc20' : '',
                        'referral' : '',
                    }}
                    validationSchema={schema}
                    onSubmit={ (values)=>{confirm(values)}}>
                    {({ handleChange, handleBlur, handleSubmit, values , errors,setFieldTouched , touched })=>(


                        <View style={{flex : 1,justifyContent : 'flex-start'}}>
                            <ScrollView style={styles.box2}>


                                <View>
                                    <Text style={styles.label}>
                                        Email :
                                    </Text>
                                    <View style={{flexDirection : 'row'}}>


                                        <TextInput


                                            style={styles.textinput}
                                            onChangeText={handleChange('email')}
                                            value={values.email}
                                            onBlur={()=>setFieldTouched('email')}
                                            showError={touched.email}
                                            error={errors.email}
                                        />
                                    </View>
                                    {touched.email &&
                                        <>
                                            {errors.email &&
                                                <Text style={styles.error}>{errors.email}</Text>
                                            }
                                        </>
                                    }

                                </View>

                                <View>
                                    <Text style={styles.label}>
                                        Full Name :
                                    </Text>
                                    <View style={{flexDirection : 'row'}}>


                                        <TextInput
                                            style={styles.textinput}
                                            onChangeText={handleChange('full_name')}
                                            value={values.full_name}
                                            onBlur={()=>setFieldTouched('full_name')}
                                            showError={touched.full_name}
                                            error={errors.full_name}
                                        />
                                    </View>
                                    {touched.full_name &&
                                        <>
                                            {errors.full_name &&
                                                <Text style={styles.error}>{errors.full_name}</Text>
                                            }
                                        </>
                                    }
                                </View>



                                <View>
                                    <Text style={styles.label}>
                                        wallet Address :
                                    </Text>
                                    <View style={{flexDirection : 'row'}}>


                                        <TextInput

                                            style={styles.textinput}
                                            onChangeText={handleChange('trc20')}
                                            value={values.trc20}
                                            onBlur={()=>setFieldTouched('trc20')}
                                            showError={touched.trc20}
                                            error={errors.trc20}
                                        />
                                    </View>
                                    {touched.trc20 &&
                                        <>
                                            {errors.trc20 &&
                                                <Text style={styles.error}>{errors.trc20}</Text>
                                            }
                                        </>
                                    }

                                </View>

                                {toast.length &&
                                    <ToastNotification
                                        // textStyle={{ color: 'red' }}
                                        // style={{ backgroundColor: 'yellow' }}
                                        text={toast}
                                        // duration={99999999999}
                                        isTop={true}
                                        style={{ padding: RFValue(10) }}
                                    />
                                }

                                <View>
                                    <Text style={styles.label}>
                                        Password :
                                    </Text>
                                    <View style={{flexDirection : 'row'}}>


                                        <TextInput
                                            secureTextEntry={true}
                                            style={styles.textinput}
                                            onChangeText={handleChange('password')}
                                            value={values.password}
                                            onBlur={()=>setFieldTouched('password')}
                                            showError={touched.password}
                                            error={errors.password}
                                        />
                                    </View>

                                    {touched.password &&
                                        <>
                                            {errors.password &&
                                                <Text style={styles.error}>{errors.password}</Text>
                                            }
                                        </>
                                    }

                                </View>

                                <View>
                                    <Text style={styles.label}>
                                        Referral (optional):
                                    </Text>
                                    <View style={{flexDirection : 'row'}}>


                                        <TextInput
                                            secureTextEntry={true}
                                            style={styles.textinput}
                                            onChangeText={handleChange('referral')}
                                            value={values.referral}
                                            onBlur={()=>setFieldTouched('referral')}
                                            showError={touched.referral}
                                            error={errors.referral}
                                        />
                                    </View>

                                    {touched.referral &&
                                        <>
                                            {errors.referral &&
                                                <Text style={styles.error}>{errors.referral}</Text>
                                            }
                                        </>
                                    }

                                </View>










                                <View style={{paddingBottom : RFValue(20)}}>

                                    <TouchableOpacity  disabled={disable}
                                                       onPress={handleSubmit}
                                                       style={{justifyContent : 'center',alignItems : 'center', marginTop : RFValue(20)}}>
                                        <View style={styles.btn2}>
                                            <Text  style={styles.btntext}>Register</Text>
                                        </View>
                                    </TouchableOpacity>
                                </View>


                            </ScrollView>
                        </View>


                    )}

                </Formik>






            </ImageBackground>




        </View>



    );

};
const styles = StyleSheet.create({
    spanStyle : {
        position : 'absolute',
        right : RFValue(10),
        top : RFValue(5),
        color : '#FFF',
        fontSize : RFValue(25)
    },
    recivetext : {
        fontFamily : 'novaria',
        color : '#f6f6f6',
        textAlign : 'center',
        fontSize : RFValue(14),
        display : 'none' ,
        paddingVertical : RFValue(5)
    },

    textfee:{
        fontFamily : 'novaria',
        color : '#e1e1e1',
        // textAlign : 'center',
        fontSize : RFValue(12),
        paddingVertical : RFValue(10),
    },

    error : {
        fontFamily : 'novaria',
        fontSize : RFValue(12),
        color : '#9E2225',
        paddingBottom : RFValue(10),
        paddingHorizontal: RFValue(15),
    },

    label:{
        fontFamily : 'novaria',
        color : '#f6f6f6',
        // textAlign : 'center',
        fontSize : RFValue(16),
        paddingVertical : RFValue(10)
    },

    labe2:{
        fontFamily : 'novaria',
        color : '#f6f6f6',
        // textAlign : 'center',
        fontSize : RFValue(16),
        paddingVertical : RFValue(10),
        flexDirection : 'row',
        justifyContent : "space-between",
    },
    textinput : {
        fontSize : RFValue(16),
        paddingVertical : RFValue(10),
        paddingHorizontal : RFValue(10),
        borderWidth : 1,
        color : '#e1e1e1',
        borderColor : '#f6f6f6',
        width : '99%',
        borderRadius : RFValue(4)

    },


    btn2 : {

        borderWidth : 1,
        borderColor : 'transparent',
        width : '30%',
        margin : "auto",
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(5),
        borderRadius : RFValue(5),
        backgroundColor : '#009688'
    },

    btn : {

        borderWidth : 1,
        borderColor : '#FFF',
        width : RFValue(120),
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(3),
        borderRadius : RFValue(5),
        backgroundColor : 'transparent',
        marginHorizontal : RFValue(5)
    },

    btntext : {
        color : '#FFF',
        fontFamily : 'novaria',
    },



    box2 : {
        margin : RFValue(12),
        backgroundColor : 'transparent',
        padding:RFValue(10),
        borderRadius : RFValue(10),
        flex : 1,
        // flexDirection : 'row',
    },


    headercon : {
        backgroundColor : 'transparent',
        flexDirection : 'row',
        alignItems : "center",
        paddingVertical : RFValue(3),
        paddingHorizontal : RFValue(25),
        // borderTopWidth : 1,
        // borderTopColor : '#FFF',

        borderBottomWidth : 1,
        borderBottomColor : '#f6f6f6',

    },
    header : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'center',
        fontSize : RFValue(25),
        // padding : RFValue(5),

        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3,
        flex : 1,
        marginRight : RFValue(20)


    },


    box : {
        // backgroundColor : '#FFF',
        padding : RFValue(7),
        margin : RFValue(5),
    }
    ,
    imgmid : {
        justifyContent : 'center',
        alignItems : 'center',
    }
    ,
    img :{
        borderRadius : RFValue(100),
        objectFit  : 'cover',
    },


    button : {
        backgroundColor : '#61dafb' ,
        padding:RFValue(10),
        borderRadius:RFValue(5),
        marginTop:RFValue(20),
    }
    ,
    buttontext : {
        color:'white',
        fontFamily:'novaria',
        textAlign:'center',
        fontSize:RFValue(12)
    }



});

export default Register;
